import { b as _extends, d as _inheritsLoose, e as _assertThisInitialized, f as _defineProperty } from './chunk-fb907809.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { theme, withProp, prop } from 'styled-tools';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { a as numberToPx } from './chunk-a7ce379e.js';
import styled from './styled.js';
import as from './as.js';
import Box from './Box.js';
import { findDOMNode } from 'react-dom';
import { a as callAll } from './chunk-d8771a86.js';
import 'styled-components';
import '@emotion/is-prop-valid';
import './chunk-a44fd1b3.js';

var Component = function Component(props) {
  return React__default.createElement(Box, _extends({
    "aria-orientation": props.vertical ? "vertical" : "horizontal"
  }, props));
};

hoistNonReactStatics(Component, Box);
var Toolbar = styled(Component).withConfig({
  displayName: "Toolbar",
  componentId: "sc-1jdzjor-0"
})(["position:relative;display:grid;width:100%;padding:", ";grid-gap:", ";grid-template:\"start center end\" / 1fr auto 1fr;&[aria-orientation=\"vertical\"]{width:min-content;height:100%;grid-template:\"start\" 1fr \"center\" auto \"end\" 1fr;}", ";"], withProp("gutter", numberToPx), withProp("gutter", numberToPx), theme("Toolbar"));
Toolbar.propTypes = {
  gutter: PropTypes__default.oneOfType([PropTypes__default.number, PropTypes__default.string]),
  vertical: PropTypes__default.bool
};
Toolbar.defaultProps = {
  role: "toolbar",
  gutter: 8
};
var Toolbar$1 = as("div")(Toolbar);

var Component$1 =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Component, _React$Component);

  function Component(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInitialTabIndex", function () {
      var tabIndex = _this.props.tabIndex;
      return typeof tabIndex !== "undefined" ? tabIndex : -1;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElement", function () {
      if (typeof _this.element === "undefined") {
        _this.element = findDOMNode(_assertThisInitialized(_assertThisInitialized(_this)));
      }

      return _this.element;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getToolbar", function () {
      if (typeof _this.toolbar === "undefined") {
        _this.toolbar = _this.getElement().closest("." + Toolbar$1.styledComponentId);
      }

      return _this.toolbar;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFocusables", function () {
      if (!_this.getToolbar()) return [];
      return _this.getToolbar().querySelectorAll("." + ToolbarFocusable.styledComponentId);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getCurrentIndex", function (focusables) {
      var currentIndex = -1;
      focusables.forEach(function (item, i) {
        if (item === _this.getElement()) {
          currentIndex = i;
        }
      });
      return currentIndex;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getNextFocusable", function (focusables, currentIndex) {
      var index = currentIndex + 1;
      return focusables.item(index) || focusables.item(0);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPreviousFocusable", function (focusables, currentIndex) {
      var index = currentIndex ? currentIndex - 1 : focusables.length - 1;
      return focusables.item(index);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toolbarIsVertical", function () {
      if (!_this.getToolbar()) return false;
      return _this.getToolbar().getAttribute("aria-orientation") === "vertical";
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "addKeyDownHandler", function () {
      if (!_this.getToolbar()) return;

      _this.getElement().addEventListener("keydown", _this.handleKeyDown);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeKeyDownHandler", function () {
      if (!_this.getToolbar()) return;

      _this.getElement().removeEventListener("keydown", _this.handleKeyDown);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyDown", function (e) {
      var isVertical = _this.toolbarIsVertical();

      var nextKey = isVertical ? "ArrowDown" : "ArrowRight";
      var previousKey = isVertical ? "ArrowUp" : "ArrowLeft";
      var willPerformEvent = [nextKey, previousKey].indexOf(e.key) >= 0;
      if (!willPerformEvent) return;

      var focusables = _this.getFocusables();

      var currentIndex = _this.getCurrentIndex(focusables);

      e.preventDefault();

      _this.setState({
        tabIndex: _this.getInitialTabIndex()
      });

      if (e.key === nextKey) {
        _this.getNextFocusable(focusables, currentIndex).focus();
      } else {
        _this.getPreviousFocusable(focusables, currentIndex).focus();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleFocus", function () {
      _this.setState({
        tabIndex: 0
      });
    });

    _this.state = {
      tabIndex: _this.getInitialTabIndex()
    };
    return _this;
  }

  var _proto = Component.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.getCurrentIndex(this.getFocusables()) === 0) {
      this.setState({
        tabIndex: 0
      });
    }

    if (!this.props.disabled) {
      this.addKeyDownHandler();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var disabled = this.props.disabled;

    if (prevProps.disabled !== disabled) {
      if (disabled) {
        this.removeKeyDownHandler();
      } else {
        this.addKeyDownHandler();
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeKeyDownHandler();
  };

  _proto.render = function render() {
    return React__default.createElement(Box, _extends({}, this.props, {
      onFocus: callAll(this.handleFocus, this.props.onFocus),
      tabIndex: this.state.tabIndex
    }));
  };

  return Component;
}(React__default.Component);

_defineProperty(Component$1, "propTypes", {
  tabIndex: PropTypes__default.number,
  onFocus: PropTypes__default.func,
  disabled: PropTypes__default.bool
});

hoistNonReactStatics(Component$1, Box);
var ToolbarFocusable = styled(Component$1).withConfig({
  displayName: "ToolbarFocusable",
  componentId: "a5g5fl-0"
})(["", ";"], theme("ToolbarFocusable"));
var ToolbarFocusable$1 = as("div")(ToolbarFocusable);

var ToolbarContent = styled(Box).withConfig({
  displayName: "ToolbarContent",
  componentId: "sc-1uhenal-0"
})(["display:grid;grid-auto-flow:column;grid-auto-columns:min-content;grid-gap:inherit;grid-area:", ";justify-content:", ";align-items:center;[aria-orientation=\"vertical\"] > &{grid-auto-flow:row;grid-auto-rows:min-content;justify-content:initial;align-content:", ";}", ";"], prop("align"), prop("align"), prop("align"), theme("ToolbarContent"));
ToolbarContent.propTypes = {
  align: PropTypes__default.oneOf(["start", "center", "end"])
};
ToolbarContent.defaultProps = {
  align: "start"
};
var ToolbarContent$1 = as("div")(ToolbarContent);

Toolbar$1.Focusable = ToolbarFocusable$1;
Toolbar$1.Content = ToolbarContent$1;

export default Toolbar$1;
